import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const prizes = {
  'Bianca': {
    amount: 1, color: '#FFFFFF', label: 'Cintura Bianca',
    prize: 'Badge Digitale',
    desc: 'Il tuo badge personalizzato con nome e cintura, condivisibile sui social.',
    preview: (name) => (
      <div className="w-64 h-40 bg-black border-2 border-white/40 rounded-lg flex flex-col items-center justify-center mx-auto"
        style={{ boxShadow: '0 0 20px rgba(255,255,255,0.1)' }}>
        <p className="font-mono font-black text-[#00FF41] text-2xl mb-1">&lt; /</p>
        <p className="font-bold text-white text-lg">{name || 'IL TUO NOME'}</p>
        <div className="w-12 h-2 bg-white rounded-sm mt-2" />
        <p className="text-zinc-500 text-[10px] font-mono mt-2">FONDATORE AI_COVO.TECH®</p>
      </div>
    ),
  },
  'Arancione': {
    amount: 5, color: '#F97316', label: 'Cintura Arancione',
    prize: 'Penna Total Black',
    desc: 'Penna elegante total black con incisione nicklogo </ e il tuo nome in neon green.',
    preview: (name) => (
      <div className="w-72 mx-auto">
        <svg viewBox="0 0 320 60" className="w-full">
          <rect x="30" y="18" width="260" height="24" rx="12" fill="#111" stroke="#333" strokeWidth="1" />
          <rect x="270" y="14" width="20" height="32" rx="4" fill="#222" />
          <circle cx="278" cy="30" r="4" fill="#333" />
          <text x="90" y="34" fill="#00FF41" fontSize="10" fontFamily="monospace" fontWeight="bold">&lt; / {name || 'IL TUO NOME'}</text>
        </svg>
        <p className="text-zinc-500 text-xs text-center mt-2">Incisione laser personalizzata</p>
      </div>
    ),
  },
  'Verde': {
    amount: 10, color: '#22C55E', label: 'Cintura Verde',
    prize: 'Supporto Smartphone Bamboo',
    desc: 'Supporto in legno di bamboo con il tuo nome inciso + nicklogo </ per scrivania.',
    preview: (name) => (
      <div className="w-56 mx-auto">
        <svg viewBox="0 0 240 160" className="w-full">
          <rect x="60" y="80" width="120" height="60" rx="8" fill="#8B6914" opacity="0.9" />
          <rect x="65" y="85" width="110" height="50" rx="6" fill="#A0792C" />
          <rect x="80" y="20" width="80" height="70" rx="8" fill="#111" stroke="#333" strokeWidth="2" />
          <rect x="84" y="24" width="72" height="62" rx="6" fill="#1a1a1a" />
          <text x="120" y="55" textAnchor="middle" fill="#00FF41" fontSize="8" fontFamily="monospace">&lt;/AI_COVO&gt;</text>
          <text x="120" y="115" textAnchor="middle" fill="#00FF41" fontSize="9" fontFamily="monospace" fontWeight="bold">&lt; / {name || 'NOME'}</text>
          <text x="120" y="128" textAnchor="middle" fill="#5C3D10" fontSize="7" fontFamily="monospace">BAMBOO STAND</text>
        </svg>
        <p className="text-zinc-500 text-xs text-center mt-2">Incisione su legno naturale</p>
      </div>
    ),
  },
  'Blu': {
    amount: 15, color: '#3B82F6', label: 'Cintura Blu',
    prize: 'T-Shirt Personalizzata',
    desc: 'T-shirt total black premium con il tuo nome nella tua cintura + nicklogo </ verde Matrix.',
    preview: (name, beltColor) => (
      <div className="w-56 mx-auto">
        <svg viewBox="0 0 220 240" className="w-full">
          <path d="M60 60 L30 80 L30 100 L50 95 L50 220 L170 220 L170 95 L190 100 L190 80 L160 60 Z" fill="#111" stroke="#222" strokeWidth="1" />
          <path d="M80 60 Q110 75 140 60" fill="none" stroke="#333" strokeWidth="2" />
          <text x="110" y="120" textAnchor="middle" fill="#00FF41" fontSize="22" fontFamily="monospace" fontWeight="900">&lt; /</text>
          <text x="110" y="150" textAnchor="middle" fill={beltColor || '#3B82F6'} fontSize="13" fontFamily="monospace" fontWeight="bold">{name || 'IL TUO NOME'}</text>
          <text x="110" y="170" textAnchor="middle" fill="#333" fontSize="7" fontFamily="monospace">AI_COVO.TECH®</text>
        </svg>
        <p className="text-zinc-500 text-xs text-center mt-2">Il colore del nome = il colore della tua cintura</p>
      </div>
    ),
  },
  'Marrone': {
    amount: 19, color: '#92400E', label: 'Cintura Marrone',
    prize: 'T-Shirt + Penna',
    desc: 'Combo: T-shirt personalizzata + penna total black. Entrambe con il tuo nome.',
    preview: (name) => (
      <div className="flex gap-4 justify-center items-end">
        <div className="w-32">
          <svg viewBox="0 0 140 160" className="w-full">
            <path d="M30 30 L15 40 L15 50 L25 48 L25 140 L115 140 L115 48 L125 50 L125 40 L110 30 Z" fill="#111" stroke="#222" strokeWidth="1" />
            <text x="70" y="75" textAnchor="middle" fill="#00FF41" fontSize="16" fontFamily="monospace" fontWeight="900">&lt; /</text>
            <text x="70" y="95" textAnchor="middle" fill="#92400E" fontSize="9" fontFamily="monospace" fontWeight="bold">{name || 'NOME'}</text>
          </svg>
        </div>
        <div className="text-3xl mb-4">+</div>
        <div className="w-32">
          <svg viewBox="0 0 140 30" className="w-full">
            <rect x="10" y="5" width="120" height="18" rx="9" fill="#111" stroke="#333" strokeWidth="1" />
            <text x="70" y="18" textAnchor="middle" fill="#00FF41" fontSize="7" fontFamily="monospace">&lt;/ {name || 'NOME'}</text>
          </svg>
        </div>
      </div>
    ),
  },
  'Rossa': {
    amount: 50, color: '#DC2626', label: 'Cintura Rossa',
    prize: 'Cintura in Vera Pelle',
    desc: 'Cintura in vera pelle italiana con logo AI_COVO.TECH® impresso a fuoco. Per chi la indossa con orgoglio.',
    preview: (name, _, companyLogo) => (
      <div className="w-72 mx-auto">
        <svg viewBox="0 0 320 80" className="w-full">
          <rect x="10" y="20" width="300" height="40" rx="6" fill="#3D1C0A" />
          <rect x="15" y="25" width="290" height="30" rx="4" fill="#5C2D0E" />
          <rect x="135" y="15" width="50" height="50" rx="8" fill="#333" stroke="#DC2626" strokeWidth="2" />
          {companyLogo ? (
            <text x="160" y="45" textAnchor="middle" fill="#DC2626" fontSize="8" fontFamily="monospace" fontWeight="bold">{companyLogo}</text>
          ) : (
            <text x="160" y="45" textAnchor="middle" fill="#00FF41" fontSize="12" fontFamily="monospace" fontWeight="900">&lt; /</text>
          )}
          <text x="70" y="43" textAnchor="middle" fill="#00FF41" fontSize="8" fontFamily="monospace">{name || 'AI_COVO.TECH®'}</text>
          <text x="250" y="43" textAnchor="middle" fill="#8B4513" fontSize="7" fontFamily="monospace">VERA PELLE</text>
        </svg>
        <p className="text-zinc-500 text-xs text-center mt-3">Impressione a fuoco — logo azienda o nicklogo</p>
      </div>
    ),
  },
  'Gran Maestro': {
    amount: 100, color: '#FFD700', label: 'Gran Maestro',
    prize: 'Bundle Completo',
    desc: 'Cover Tablet + Smartphone + T-shirt + Penna + Supporto Bamboo. Tutto personalizzato col tuo nome.',
    preview: (name) => (
      <div className="w-72 mx-auto">
        <svg viewBox="0 0 300 200" className="w-full">
          <rect x="30" y="10" width="120" height="90" rx="10" fill="#111" stroke="#FFD700" strokeWidth="1.5" />
          <text x="90" y="50" textAnchor="middle" fill="#00FF41" fontSize="14" fontFamily="monospace" fontWeight="900">&lt; /</text>
          <text x="90" y="70" textAnchor="middle" fill="#FFD700" fontSize="8" fontFamily="monospace">{name || 'NOME'}</text>
          <text x="90" y="85" textAnchor="middle" fill="#555" fontSize="6" fontFamily="monospace">COVER TABLET</text>

          <rect x="170" y="25" width="55" height="75" rx="6" fill="#111" stroke="#FFD700" strokeWidth="1.5" />
          <text x="198" y="60" textAnchor="middle" fill="#00FF41" fontSize="10" fontFamily="monospace" fontWeight="900">&lt;/</text>
          <text x="198" y="73" textAnchor="middle" fill="#FFD700" fontSize="6" fontFamily="monospace">{name ? name.slice(0,6) : 'NOME'}</text>
          <text x="198" y="90" textAnchor="middle" fill="#555" fontSize="5" fontFamily="monospace">COVER PHONE</text>

          <path d="M30 130 L20 138 L20 145 L27 143 L27 190 L93 190 L93 143 L100 145 L100 138 L90 130 Z" fill="#111" stroke="#FFD700" strokeWidth="1" />
          <text x="60" y="160" textAnchor="middle" fill="#00FF41" fontSize="10" fontFamily="monospace" fontWeight="900">&lt; /</text>
          <text x="60" y="175" textAnchor="middle" fill="#FFD700" fontSize="7" fontFamily="monospace">{name || 'NOME'}</text>

          <rect x="110" y="155" width="80" height="12" rx="6" fill="#111" stroke="#FFD700" strokeWidth="1" />
          <text x="150" y="164" textAnchor="middle" fill="#00FF41" fontSize="6" fontFamily="monospace">&lt;/ {name || 'NOME'}</text>

          <rect x="200" y="130" width="70" height="50" rx="6" fill="#8B6914" opacity="0.8" stroke="#FFD700" strokeWidth="1" />
          <text x="235" y="155" textAnchor="middle" fill="#00FF41" fontSize="7" fontFamily="monospace">&lt;/ {name ? name.slice(0,5) : 'NOME'}</text>
          <text x="235" y="170" textAnchor="middle" fill="#5C3D10" fontSize="5" fontFamily="monospace">BAMBOO</text>
        </svg>
        <p className="text-[#FFD700] text-xs text-center mt-2 font-bold">5 prodotti, tutti col tuo nome</p>
      </div>
    ),
  },
};

const PrizePreview = ({ isOpen, onClose, beltKey }) => {
  const [name, setName] = useState('');
  const [companyLogo, setCompanyLogo] = useState('');
  const prize = prizes[beltKey];

  if (!isOpen || !prize) return null;

  return (
    <div className="fixed inset-0 z-[99999] flex items-center justify-center bg-black/80 backdrop-blur-sm px-4"
      onClick={onClose}>
      <div className="bg-[#0A0A0A] border-2 max-w-lg w-full max-h-[90vh] overflow-y-auto"
        style={{ borderColor: `${prize.color}66`, boxShadow: `0 0 40px ${prize.color}22` }}
        onClick={e => e.stopPropagation()}>
        
        {/* Header */}
        <div className="p-6 border-b" style={{ borderColor: `${prize.color}22` }}>
          <div className="flex items-center justify-between mb-2">
            <div className="flex items-center gap-3">
              <div className="w-8 h-3 rounded-sm" style={{ background: prize.color }} />
              <span className="font-mono text-sm font-bold" style={{ color: prize.color }}>{prize.label}</span>
            </div>
            <button onClick={onClose} className="text-zinc-500 hover:text-white transition-colors" data-testid="prize-close">
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
          <p className="text-2xl font-black" style={{ color: prize.color }}>{prize.amount}€</p>
          <h3 className="text-xl font-bold text-white mt-1">{prize.prize}</h3>
          <p className="text-zinc-400 text-sm mt-2">{prize.desc}</p>
        </div>

        {/* Name input */}
        <div className="p-6 border-b" style={{ borderColor: `${prize.color}22` }}>
          <label className="block text-sm font-mono text-zinc-400 mb-2">
            Scrivi il tuo nome per vedere l'anteprima:
          </label>
          <input
            type="text"
            value={name}
            onChange={e => setName(e.target.value.toUpperCase())}
            placeholder="IL TUO NOME"
            maxLength={20}
            className="w-full bg-black border-2 text-white p-3 font-mono font-bold text-center text-lg tracking-wider focus:outline-none transition-colors"
            style={{ borderColor: `${prize.color}44`, color: prize.color }}
            data-testid="prize-name-input"
            autoFocus
          />
          {(beltKey === 'Rossa') && (
            <div className="mt-3">
              <label className="block text-sm font-mono text-zinc-400 mb-2">
                Logo azienda (opzionale):
              </label>
              <input
                type="text"
                value={companyLogo}
                onChange={e => setCompanyLogo(e.target.value.toUpperCase())}
                placeholder="NOME BRAND"
                maxLength={12}
                className="w-full bg-black border border-zinc-700 text-white p-2 font-mono text-center text-sm focus:outline-none focus:border-red-500/50"
                data-testid="prize-company-input"
              />
            </div>
          )}
        </div>

        {/* Live preview */}
        <div className="p-6" data-testid="prize-preview">
          <p className="font-mono text-xs text-[#00FF41] uppercase tracking-wider mb-4 text-center">Anteprima Live</p>
          {prize.preview(name, prize.color, companyLogo)}
        </div>

        {/* CTA */}
        <div className="p-6 pt-0">
          <Link to="/dona" onClick={onClose}
            className="block w-full text-center font-bold py-3 transition-colors"
            style={{ background: prize.color, color: '#000' }}
            data-testid="prize-cta-dona">
            Dona {prize.amount}€ e Ricevi il Tuo Premio
          </Link>
        </div>
      </div>
    </div>
  );
};

export { prizes };
export default PrizePreview;
